function DuplicateApplication() {}

DuplicateApplication.parent = "#duplicate-application-modal";

DuplicateApplication.application = null;

DuplicateApplication.events = {
    isInit: true,
    
    init: function() {
        var self = this;
        if (self.isInit) {
            $(DuplicateApplication.parent).on("click", ".duplicate-menu .current-location", self.onSelectCurrentLocation);
            $(DuplicateApplication.parent).on("click", ".duplicate-menu .custom-location", self.onSelectCustomLocation);

            // Perspective
            $(DuplicateApplication.parent).on("click", ".perspective", self.onSelectPerspective);
            // Parts
            $(DuplicateApplication.parent).on("click", ".part-button", self.onSelectParts);
            // Side
            $(DuplicateApplication.parent).on("click", ".side-button", self.onSelectSide);
            // Duplicate
            $(DuplicateApplication.parent).on("click", ".duplicate-button", self.onDuplicate);
            
            
            self.isInit = false;
        }
    },

    onSelectCurrentLocation: function() {
        var container = $(DuplicateApplication.parent).find(".custom-location-option-container");
        var cloneObject = ub.utilities.cloneObject(DuplicateApplication.application);
        var newApplicationID = ub.funcs.getNewCustomID();

        ub.current_material.settings.applications[newApplicationID] = cloneObject;
        ub.data.applications_transformed_one_dimensional[newApplicationID] = cloneObject.application;

        var newApplication = ub.funcs.getApplicationSettings(newApplicationID);

        if (typeof newApplication !== "undefined") {
            newApplication.code = newApplicationID.toString();
            newApplication.application.id = newApplicationID.toString();
            newApplication.zIndex = ub.funcs.getNewZIndex();

            delete newApplication.custom_obj;
            delete newApplication.scale_type;
            delete newApplication.custom_size_type;
            delete newApplication.application.views[0].application.appCustomScale;

            // Add adjust position
            _.each(newApplication.application.views, function(view) {
                // Center
                view.application.center.x += 100;
                view.application.center.y += 100;

                // Pivot
                view.application.pivot.x += 100;
                view.application.pivot.y += 100;
            });

            ub.funcs.renderLocations(newApplication.code);

            if (newApplication.application_type === "mascot") {
                ub.funcs.update_application_mascot(newApplication.application, newApplication.mascot);
                ub.funcs.activateMascots(newApplication.code);
            } else if (newApplication.application_type === "embellishments") {
                ub.funcs.update_application_embellishments(newApplication.application, newApplication.embellishment);
            }

            ub.funcs.updateLayerTool();
        }

        UIkit.modal("#duplicate-application-modal").hide();
        container.addClass("uk-hidden");
    },

    onSelectPerspective: function() {
        var perspective = $(this).data("perspective");
        var availableParts = ub.funcs.getFreeFormLayers();
        // Setting
        ub.funcs.setActiveView(perspective);
        ub.dataPatches.patchForMaskHidePanel1(perspective);

        // Activate
        $(DuplicateApplication.parent).find(".perspective.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");

        // Check Sport With Extra Layer
        if (ub.data.sportsWithExtraLayer.isValid(ub.current_material.materials_options)) {
            if (perspective === "front" || perspective === "back") {
                if (ub.data.freeFormToolFirstPartSelection.activateDefaultOnUniform(ub.current_material.material.uniform_category) ||
                    _.size(availableParts) === 1
                ) {
                    $(".custom-location-option-container button.part-button").first().trigger('click');
                } else {
                    var filterParts = DuplicateApplication.checkPerspectiveInAvailableParts(perspective);
                    if (_.size(filterParts) > 0) {
                        var first = _.first(filterParts);

                        $(".custom-location-option-container button.part-button[data-part='"+ first.name +"']").trigger("click");
                    } else {
                        $(".custom-location-option-container button.part-button").first().trigger('click');
                    }
                }
            } else {
                var sideParts = DuplicateApplication.checkPerspectiveInAvailableParts(perspective);

                if (_.size(sideParts) > 0) {
                    var firstPart = _.first(sideParts);

                    $(".custom-location-option-container button.part-button[data-part='"+ firstPart.name +"']").trigger("click");
                }
            }

            if (ub.funcs.isSocks()) {
                var _part = "Sublimated";

                if (typeof ub.data.modifierLabels["Body"] !== "undefined") {
                    _part = "Body";
                }

                $(".custom-location-option-container button.part-button[data-part='"+ _part +"']").trigger("click");

            }
        }
    },

    onSelectCustomLocation: function() {
        var container = $(DuplicateApplication.parent).find(".custom-location-option-container");

        if ($(container).hasClass("uk-hidden")) {
            container.removeClass("uk-hidden");
            $(this).addClass("uk-active");
        } else {
            container.addClass("uk-hidden");
            $(this).removeClass("uk-active");
        }
    },

    onSelectParts: function() {
        var part = $(this).data("part");
        var perspective = $(".perspective.uk-active", DuplicateApplication.parent).data("perspective");
        var leftPart = _.find(ub.current_material.materials_options, {name: "Left " + part});

        if (typeof leftPart !== "undefined") {
            if (perspective === "front" || perspective === "back") {
                DuplicateApplication.changeActivePerspective("left");
                DuplicateApplication.renderSide(part, "left");
            } else {
                DuplicateApplication.renderSide(part, perspective);
            }
        } else {
            $(".side-container", DuplicateApplication.parent).html("");

            if (part.includes("front") || part.includes("Front")) {
                DuplicateApplication.changeActivePerspective("front")
            } else if (part.includes("back") || part.includes("Back")) {
                DuplicateApplication.changeActivePerspective("back");
            }
        }
    
        $(".custom-location-option-container button.part-button.uk-active").removeClass("uk-active");
        $(this).addClass("uk-active");
    },

    onSelectSide: function() {
        var side = $(this).data("side");
        
        $(".side-button.uk-active", DuplicateApplication.parent).removeClass("uk-active");
        $(this).addClass("uk-active");

        ub.funcs.setActiveView(side);
        DuplicateApplication.changeActivePerspective(side);
    },

    onDuplicate: function() {
        var perspective = $(".perspective.uk-active", DuplicateApplication.parent).data("perspective");
        var part = $(".part-button.uk-active", DuplicateApplication.parent).data("part");
        var side = $(".side-button.uk-active", DuplicateApplication.parent).data("side");
        var cloneObject = ub.utilities.cloneObject(DuplicateApplication.application);

        if (QX7Rule.enabled) {
            QX7Rule.Application.cloneAppSettings(part, cloneObject, (newApp) => {
                if (cloneObject.application_type === "mascot") {
                    ApplicationCore.funcs.createMascotApplication(newApp, cloneObject.mascot, cloneObject.size, cloneObject.color_array);
                } else if (cloneObject.application_type === "embellishments") {
                    ApplicationCore.funcs.createEmbellishmentApplication(newApp, cloneObject.embellishment, cloneObject.size);
                }

                UIkit.modal("#duplicate-application-modal").hide();
                ub.funcs.setActiveView(newApp.perspective);
            });

            return;
        }

        ApplicationCore.funcs.createNewPlainApplication(perspective, part, side, "Duplicate", function(applicationSettings) {
            // Copy Scale
            var clonePrimary = ub.funcs.getPrimaryViewObject(cloneObject.application);
            var applicationViews = applicationSettings.application.views;

            if (typeof clonePrimary.application !== "undefined") {
                if (typeof clonePrimary.application.scale !== "undefined") {
                    if (_.size(applicationViews) > 0) {
                        _.each(applicationViews, function(view) {
                            if (typeof view.application !== "undefined") {
                                view.application.scale = clonePrimary.application.scale;
                            } else {
                                console.log("Cannot find application view");
                            }
                        });
                    }
                }
            }

            if (cloneObject.application_type === "mascot") {
                ApplicationCore.funcs.createMascotApplication(applicationSettings, cloneObject.mascot, cloneObject.size, cloneObject.color_array);
            } else if (cloneObject.application_type === "embellishments") {
                ApplicationCore.funcs.createEmbellishmentApplication(applicationSettings, cloneObject.embellishment, cloneObject.size);
            }

            UIkit.modal("#duplicate-application-modal").hide();
        });
    }
};

DuplicateApplication.changeActivePerspective = function(perspective) {
    $(".perspective.uk-active", DuplicateApplication.parent).removeClass("uk-active");
    $(".perspective[data-perspective='"+ perspective +"']", DuplicateApplication.parent).addClass("uk-active");
};

DuplicateApplication.checkPerspectiveInAvailableParts = function(perspective) {
    var availableParts = ub.funcs.getFreeFormLayers();
    // Force Left
    if (perspective === "right" || perspective === "Right") {
        perspective = "left";
    }

    var filterParts = _.filter(availableParts, function(part) {
        if (part.fullname.includes(perspective.toLowerCase())) {
            return part;
        }
    });

    return filterParts;
};

DuplicateApplication.postRender = function() {
    $(DuplicateApplication.parent).find(".custom-location-option-container").addClass("uk-hidden");
    $(DuplicateApplication.parent).find(".duplicate-menu button.uk-active").removeClass("uk-active");

    $(".perspective[data-perspective='"+ ub.active_view +"']", DuplicateApplication.parent).trigger("click");

    // hide perspective button in customizer sidebar
    ub.data.manipulatePerspectives.getPerspectives(ub.sport, function(perspectives) {
        _.each(perspectives, function(perspective) {
            $(".perspective[data-perspective='"+ perspective.toLowerCase() +"']", DuplicateApplication.parent).parent().addClass("uk-hidden");
        });
    });

    // Hide the part in free form appplication
    ub.data.manipulatePerspectives.getParts(ub.sport, function(sportparts){
        var BLOCK_WITH_POCKET = ['Tech Tee Short Sleeve Hoodie with Pocket', 'Tech Tee Long Sleeve Hoodie with Pocket', 'Tech Tee Sleeveless Hoodie with Pocket'];
        
        var parts = sportparts;
            parts = (_.contains(BLOCK_WITH_POCKET, ub.config.option)) ? parts = _.without(parts, 'Pocket') : parts;
        
        _.each(parts, function(part) {
            $(".part-button[data-part='"+ part +"']", DuplicateApplication.parent).parent().remove();
        });
    });

    if ($(".part-button", DuplicateApplication.parent).length === 1) {
        $(".part-button", DuplicateApplication.parent).first().addClass("uk-active");
    }
};

DuplicateApplication.render = function(application) {
    DuplicateApplication.application = application;
    var parts = ub.funcs.getFreeFormLayers();
    var tmpl = _.template($("#custom-location-option-template").html());
    var container = $(DuplicateApplication.parent).find(".custom-location-option-container");
    var thumbnail, name;

    $(container).html("");

    if (QX7Rule.enabled) {
        tmpl = _.template($("#qx7-custom-location-option-template").html());
        $(container).html(tmpl({
            locations: QX7Rule.Application.getAvailableLocations()
        }));
    } else {
        $(container).html(tmpl({
            parts: parts,
            sports: ub.sport
        }));
    }

    $(container).addClass("uk-hidden");

    if (application.application_type === "mascot") {
        if (typeof application.mascot !== "undefined") {
            thumbnail = application.mascot.icon;
            name = application.mascot.name;
        }
    } else if (application.application_type === "embellishments") {
        if (typeof application.embellishment !== "undefined") {
            thumbnail = application.embellishment.png_filename;
            name = application.embellishment.name;
        }
    }
    
    // Pre Render
    DuplicateApplication.renderThumbnail(thumbnail, name);
    // Post Render
    DuplicateApplication.events.init();
    DuplicateApplication.postRender();

    UIkit.modal("#duplicate-application-modal").show();
};

DuplicateApplication.renderSide = function(part, perspective) {
    var tmpl = _.template($("#custom-location-side-option-template").html());
    var container = $(".side-container", DuplicateApplication.parent);

    $(container).html("");
    $(container).html(tmpl({
        part: part,
        perspective: perspective
    }));
};

DuplicateApplication.renderThumbnail = function(thumbnail, name) {
    var tmpl = _.template($("#duplication-application-thumbnail-template").html());
    var container = $(".thumbnail-container", DuplicateApplication.parent);

    $(container).html("");
    $(container).html(tmpl({
        thumbnail: thumbnail,
        name: name
    }));
};